module.exports = __webpack_public_path__ + "static/media/72.f63ae47e.jpg";